export const BEER_INGESTION_SCROLL_STORAGE_KEY = 'beerIngestion.scroll';
export const BEER_INGESTION_ROW_ID_PREFIX = 'beer-ingestion-row-';

export function beerIngestionRowElementId(breweryId) {
  if (typeof breweryId !== 'string' || breweryId.trim() === '') {
    return null;
  }
  return `${BEER_INGESTION_ROW_ID_PREFIX}${breweryId}`;
}

export function readBeerIngestionScrollPosition() {
  try {
    const raw = window.sessionStorage.getItem(BEER_INGESTION_SCROLL_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }
    const scrollY = Number(parsed.scrollY);
    if (!Number.isFinite(scrollY) || scrollY < 0) {
      return null;
    }
    return {
      scrollY,
      usState: typeof parsed.usState === 'string' ? parsed.usState : null,
      breweryId:
        typeof parsed.breweryId === 'string' && parsed.breweryId.trim() !== ''
          ? parsed.breweryId
          : null,
    };
  } catch {
    return null;
  }
}

export function writeBeerIngestionScrollPosition(nextPosition = {}) {
  try {
    const current = readBeerIngestionScrollPosition() || {
      scrollY: 0,
      usState: null,
      breweryId: null,
    };
    const hasExplicitBreweryId = Object.prototype.hasOwnProperty.call(
      nextPosition,
      'breweryId',
    );
    const payload = {
      scrollY: Number.isFinite(nextPosition.scrollY) ? nextPosition.scrollY : current.scrollY,
      usState:
        typeof nextPosition.usState === 'string' ? nextPosition.usState : current.usState,
      breweryId: hasExplicitBreweryId
        ? nextPosition.breweryId || null
        : current.breweryId,
    };
    window.sessionStorage.setItem(
      BEER_INGESTION_SCROLL_STORAGE_KEY,
      JSON.stringify(payload),
    );
    return payload;
  } catch {
    return null;
  }
}

export function captureBeerIngestionScrollPosition(options = {}) {
  const nextPosition = {
    usState: options.usState,
    scrollY: typeof window.scrollY === 'number' ? window.scrollY : 0,
  };
  if (Object.prototype.hasOwnProperty.call(options, 'breweryId')) {
    nextPosition.breweryId = options.breweryId;
  }
  return writeBeerIngestionScrollPosition(nextPosition);
}

export function restoreBeerIngestionScrollPosition(position) {
  if (!position) {
    return false;
  }
  const rowElementId = beerIngestionRowElementId(position.breweryId);
  const rowElement = rowElementId ? document.getElementById(rowElementId) : null;
  if (rowElement && typeof rowElement.scrollIntoView === 'function') {
    rowElement.scrollIntoView({ block: 'start' });
    return true;
  }
  if (typeof position.scrollY === 'number') {
    window.scrollTo(0, position.scrollY);
    return true;
  }
  return false;
}
